import { render, staticRenderFns } from "./HdsIdBox.vue?vue&type=template&id=11225aef&scoped=true&"
import script from "./HdsIdBox.vue?vue&type=script&lang=js&"
export * from "./HdsIdBox.vue?vue&type=script&lang=js&"
import style0 from "./HdsIdBox.vue?vue&type=style&index=0&id=11225aef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11225aef",
  null
  
)

export default component.exports